var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiveAways(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9519 6.97976H21.8405C22.6074 5.95286 22.5775 5.0274 22.4934 4.57229C22.2806 3.42172 21.2908 2.54386 19.9717 2.33561C18.4837 2.10047 16.4634 2.69594 14.5786 4.77628C14.8503 3.56936 15.361 2.48022 16.1188 1.48517C16.4118 1.10058 16.337 0.551605 15.9521 0.259005C15.5672 -0.0335947 15.0175 0.0409553 14.7245 0.425547C13.6696 1.81067 13.0034 3.38847 12.7326 5.13526C10.7614 2.76448 8.5983 2.08787 7.02815 2.33555C5.70911 2.54375 4.71932 3.42166 4.50652 4.57223C4.42237 5.02735 4.39253 5.95275 5.15947 6.9797H2.04814C0.918777 6.9797 0 7.89746 0 9.02563V12.2781C0 13.3813 0.878891 14.2829 1.97391 14.3221V25.3711C1.97391 26.865 3.19058 28.0803 4.6861 28.0803H22.3138C23.8094 28.0803 25.026 26.865 25.026 25.3711V14.3221C26.1211 14.2829 27 13.3814 27 12.2781V9.02563C27 7.89746 26.0812 6.97976 24.9519 6.97976ZM19.6983 4.0642C20.2826 4.15643 20.6934 4.47295 20.7706 4.8902C20.8629 5.3896 20.4945 6.18946 19.2132 6.97976H15.0628C16.7353 4.58115 18.546 3.88273 19.6983 4.0642ZM6.22938 4.8902C6.30652 4.47295 6.71736 4.15643 7.30163 4.0642C8.45406 3.88238 10.2647 4.5811 11.9372 6.97976H7.78674C6.50531 6.18946 6.13705 5.3896 6.22938 4.8902ZM1.75194 12.2782V9.02569C1.75194 8.86527 1.88754 8.72976 2.04814 8.72976H12.624V12.574H2.04814C1.88754 12.574 1.75194 12.4386 1.75194 12.2782ZM3.72586 25.3712V14.324H12.624V26.3304H4.6861C4.1566 26.3304 3.72586 25.9001 3.72586 25.3712ZM22.3138 26.3304H14.376V14.324H23.2741V25.3712C23.2741 25.9001 22.8433 26.3304 22.3138 26.3304ZM25.2481 12.2781C25.2481 12.4385 25.1125 12.574 24.9519 12.574H14.376V8.7297H24.9519C25.1125 8.7297 25.2481 8.86521 25.2481 9.02563V12.2781Z",
    fill: "url(#paint0_linear_172_1128)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_172_1128",
    x1: 5.69609,
    y1: 29.0814,
    x2: 20.9512,
    y2: 2.62936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiveAways);
export default __webpack_public_path__ + "static/media/GiveAways.0d7d9218512dffa32678a3250ce07b00.svg";
export { ForwardRef as ReactComponent };